import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export const usePutFile = () =>
  useMutation({
    mutationFn: async ({ url, file }: { url: string; file: File }) => {
      if (!url) {
        return null;
      }
      const { data } = await axios.put(url, file);
      return data;
    },
  });
